var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main-layout',[_c('v-content',[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('h1',[_vm._v("Dashboard will appear here")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }